import { HTTP_TYPES } from '@/lib/enums';
import api from '@/api/api';

const response = {
  faqs: {
    async getConversations(userId: string): Promise<any> {
      return await api(
        HTTP_TYPES.GET,
        `${import.meta.env.VITE_125_API_CHAT_BASE_URL}/api/chatbot/faqs/conversations?userId=${userId}`
      )
    },
    async getConversation(conversationId: string, userId: string): Promise<any> {
      return await api(
        HTTP_TYPES.GET,
        `${import.meta.env.VITE_125_API_CHAT_BASE_URL}/api/chatbot/faqs/conversations/${conversationId}/?userId=${userId}`
      )
    },
    async sendMessage(conversationId: string, message: string, userId: string): Promise<any> {
      const payload = {
        conversationId,
        question: message,
        userId: userId
      }

      return await api(
        HTTP_TYPES.POST,
        `${import.meta.env.VITE_125_API_CHAT_BASE_URL}/api/chatbot/faqs/chat/`,
        payload
      )
    },
  }
}

export default response
